import React, { useEffect, useState } from "react";
import { CircleBtn } from "assets/css/globle";
import ChatIcon from "assets/svgIcons/ChatIcon";
import TimeIcon from "assets/svgIcons/TimeIcon";
import DeleteIcon from "assets/svgIcons/DeleteIcon";
import { COMMON_SERVICES } from "../../../../redux/reduxToolkitServices/_commonServices/commonServices";
import { useDispatch, useSelector } from "react-redux";
import { useHookstate } from "@hookstate/core";
import { useNavigate } from "react-router-dom";
import { PopUpContainer } from "assets/css/globle";
import Box from "@mui/material/Box";
import { Loader } from "commonComponents/Loader/Loader";
import { DataGrid } from "@mui/x-data-grid";
import { API_STATUSES } from "redux/_helpers/statuses";
import { TableContainer, BodyWrapper } from "assets/css/globle";
import { getFeatureSetOption, getFeaturesList, isUserAdmin, isUserMaster, isUserSupport, carType } from "../../../../constant";
import {
  MAP_GLOBAL_STATES,
  MESSAGE_FLEET_GLOBAL_STATES,
  SIDENAV_GLOBAL_STATE,
  SITEID_GLOBAL_STATE,
  CAR_NUMBER_MESSAGE,
  UPDATED_CAR_DATA_STATE
} from "globalStore/globalStore";

import {
  TagsWrapper,
  Tag,
} from "../../../../pages/Fleet/Cars/SortByHeader/SortByHeaderStyled";
import CarTagIcon from "assets/svgIcons/LocationPointIcon";
import Modal from "@mui/material/Modal";
import moment from "moment";
import { Header, TableInnerSection, ModalContainer } from "../InboxStyled";
import { Stack } from "@mui/system";
import { useTranslation } from "react-i18next";
import MarshalsCarIcon from "assets/svgIcons/CarType/Marshals";
import ForwardIcon from "assets/svgIcons/ForwardIcon";
import CloseIcon from "assets/svgIcons/CloseIcon";
import { validateCarType } from "_helperFunctions/validateCarType";
import { FaStethoscope } from "react-icons/fa";
const InboxTable = () => {
  const { t } = useTranslation();
  const { siteId } = useHookstate(SITEID_GLOBAL_STATE);
  const { taggedCarsSaverGlobalState, showTaggedCarArray } =
    useHookstate(MAP_GLOBAL_STATES);
  const {
    setCarNumber,
    carsForMessagesGetter,
    msgBtnState,
    fromMsgPage,
    carsGpsSelectorData,
    carMessageID,
  } = useHookstate(CAR_NUMBER_MESSAGE);

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    maxWidth: "400px",
    width: "100%",
    bgcolor: "background.paper",
    borderRadius: "5px",
    overflow: "hidden",
  };

  const { taggedCarsDisplayerGlobalState } = useHookstate(MAP_GLOBAL_STATES);
  const { subNavDataState, sideDrawerActiveTabState } =
    useHookstate(SIDENAV_GLOBAL_STATE);
  const { showMessageBoxForSingleCar } = useHookstate(MAP_GLOBAL_STATES);
  const { updatedCarData } = useHookstate(UPDATED_CAR_DATA_STATE);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [openDismiss, setOpenDismiss] = useState(false);
  const [openConfirmationModal, setOpenConfirmationModal] = useState(false);
  const [selectionModel, setSelectionModel] = useState([]);
  const {
    siteSettingDataReduxStateStatus,
    getMessagesFromCarsData,
    siteSettingsData,
    getUserRole,
    sendMessageToMarshalsStatus
  } = useSelector((state) => state.commonReducers) || [];
  const [messageData, setMessageData] = useState([]);
  const { isLoading } = useHookstate(MESSAGE_FLEET_GLOBAL_STATES);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const oldest = moment(new Date()).format("YYYY-MM-DD");
  const [messageIdForDeletee, setMessageIdForDeletee] = useState(null);
  const enableMemberCar = isUserAdmin(getUserRole && getUserRole?.Role) || isUserSupport(getUserRole && getUserRole?.Role) ||
    !getFeatureSetOption(siteSettingsData?.Features, getFeaturesList().member_cars);
  const isAdminOrSupport =
    isUserAdmin(getUserRole?.Role) ||
    isUserSupport(getUserRole?.Role);
  const decodeHtml = (html) => {
    const txt = document.createElement('textarea');
    txt.innerHTML = html;
    return txt.value;
  }
  useEffect(() => {
    dispatch(COMMON_SERVICES.getMessagesFromCarsServices(oldest, siteId.get()));
  }, [siteId.get()]);

  useEffect(() => {
    setMessageData([]);
  }, [siteId.get()]);

  useEffect(() => {
    let dismissedIds = JSON.parse(localStorage.getItem("dismissedIds")) || [];

    let messageDataGetter = [];

    if (getMessagesFromCarsData?.Messages?.length) {

      messageDataGetter =
        getMessagesFromCarsData.Messages
          .map((item) => {

            let updatedItem = {
              ...item,
              id: item?.Id,
              received: moment(item?.Created).unix(),
              car: item?.CarNum,
              text: item?.Text,
              response: item?.Response,
              hole: item?.Hole,
            };

            if (messageIsDiagnostic(updatedItem)) {

              updatedItem.IsDiagnostic = true;

              updatedItem.Text = updatedItem.Text
                .replace("z1lk3r -", "")
                .replace("v1s*g3 -", "");

            } else {
              updatedItem.IsDiagnostic = false;
            }

            return updatedItem;
          })

          .filter((item) => {

            // Hiding diagnostics completely for non-admin/support users

            if (item.IsDiagnostic && !isAdminOrSupport) {
              return false;
            }

            if (dismissedIds.includes(item.Id)) {
              return false;
            }

            if (
              !enableMemberCar &&
              !validateCarType(
                item?.CarNum,
                updatedCarData.get()
              )
            ) {
              return false;
            }

            return true;
          });
    }
    setMessageData(messageDataGetter);

  }, [
    getMessagesFromCarsData,
    enableMemberCar,
    isAdminOrSupport
  ]);

  function messageIsDiagnostic(msg) {
    return (
      msg?.Text?.indexOf("z1lk3r") >= 0 ||
      msg?.Text?.indexOf("v1s*g3") >= 0
    );
  }
  const forwardMessagesToMarshal = (e, item) => {
    e.stopPropagation(e);
    dispatch(
      COMMON_SERVICES.sendMessageToMarshalsServices(item.Id, siteId.get())
    ).then(() => {
      setOpenConfirmationModal(true);
    });
  };

  const sendMsgToSelectedCars = (e, item) => {
    e.stopPropagation(e);
    if (isLoading.get()) {
      isLoading.set(false);
      showMessageBoxForSingleCar.set(null);
    } else {
      isLoading.set(true);
      fromMsgPage.set(true);
      carsForMessagesGetter.set([item.CarNum]);
      carsGpsSelectorData.set([item.GpsiCarId]);
      msgBtnState.set({ state: true, activeNo: item.CarNum });
      setCarNumber.set(item.CarNum);
      carMessageID.set(item?.Id);
    }
  };

  // CODE FOR GETTING SINGLE CAR TAG
  const fleetPageRedirect = (carInfo) => {
    const exist = taggedCarsSaverGlobalState
      .get()
      .find((item) => item === carInfo?.row?.CarNum);
    if (!exist) {
      taggedCarsSaverGlobalState.set((tasks) => [
        ...tasks,
        carInfo?.row?.CarNum,
      ]);
    }

    const exist2 = showTaggedCarArray
      .get()
      .find((item) => item === carInfo?.row?.CarNum);
    if (!exist2) {
      showTaggedCarArray.set((tasks) => [...tasks, carInfo?.row?.CarNum]);
    }

    taggedCarsDisplayerGlobalState.set(true);

    localStorage.setItem(
      "taggedCarsData",
      JSON.stringify({
        findCars: true,
        taggedCarsDisplayerGlobalState: taggedCarsDisplayerGlobalState.get(),
        tagCarsDataMap: taggedCarsSaverGlobalState.get(),
        tagCarsDataFilters: showTaggedCarArray.get(),
      })
    );

    subNavDataState.set("MAP");
    sideDrawerActiveTabState.set(1);
    navigate("/map");
  };

  // CODE FOR GETTING SINGLE CAR TAG END
  //..................Delete Message Functionality..........................//

  const deleteMessage = () => {
    let id = messageIdForDeletee;
    let dismissedIds = JSON.parse(localStorage.getItem("dismissedIds"));
    dismissedIds.push(id?.row?.Id);
    localStorage.setItem("dismissedIds", JSON.stringify(dismissedIds));
    setOpenDeleteModal(false);
    handleDeleteClose();
  };

  const handleDeleteClose = () => setOpenDeleteModal(false);

  const handleCloseDismissAll = () => setOpenDismiss(false);

  const handleConfirmationClose = () => setOpenConfirmationModal(false);

  let messageResponse = {
    None: 0,
    Ok: 1,
    Yes: 2,
    No: 3,
  };

  let messageResponseText = function (response) {
    switch (response) {
      case messageResponse.None:
        return "-";
      case messageResponse.Ok:
        return "Ok";
      case messageResponse.Yes:
        return "Yes";
      case messageResponse.No:
        return "No";
      default:
        return "?";
    }
  };

  let responseString = function (message) {
    if (!message?.ToCar) return messageResponseText(message?.Response);
    return ""; // blank for messages TO car
  };

  let holeString = function (message) {
    if (!message?.ToCar) {
      if (
        siteSettingsData?.Courses?.length > 1 &&
        message?.Course &&
        message?.Hole
      ) {
        return message?.Course + message?.Hole.toString();
      } else if (message?.Hole) {
        return message?.Hole.toString();
      } else return "-";
    }
    return "";
  };
  var recvTime = function (message) {
    var sent = moment.utc(message.Created);
    if (siteSettingsData) sent.utcOffset(-siteSettingsData.TimeZoneOffset); // convert to course's timezone for display here

    return sent.format("hh:mm a");
  };

  const singleMessageDelete = () => {
    return (
      <Modal
        open={openDeleteModal}
        onClose={handleDeleteClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <PopUpContainer>
            <h2>{t("Confirm")}</h2>
            <p>{t("Delete_message")}?</p>
            <div className="action-btn">
              <button
                className="primary"
                onClick={() => deleteMessage()}
                variant="contained"
              >
                {t("Yes")}
              </button>
              <button onClick={() => handleDeleteClose()}>{t("No")}</button>
            </div>
          </PopUpContainer>
        </Box>
      </Modal>
    );
  };

  const multipleMessagesDelete = () => {
    return (
      <Modal
        open={openDismiss}
        onClose={handleCloseDismissAll}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <PopUpContainer>
            <h2>{t("Confirm")}</h2>
            <p>{t("Dismiss_all_messages_in_inbox")}?</p>
            <div className="action-btn">
              <button
                className="primary"
                onClick={dismissMessages}
                variant="contained"
              >
                {t("Yes")}
              </button>
              <button onClick={() => handleCloseDismissAll()}>{t("No")}</button>
            </div>
          </PopUpContainer>
        </Box>
      </Modal>
    );
  };

  const confirmationModal = () => {
    return (
      <Modal
        open={openConfirmationModal}
        onClose={handleConfirmationClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <PopUpContainer>
            <ModalContainer>
              <div className="modal-container-parent">
                <div className="modal-title-icon">
                  <div className="modal-title">
                    <h5>{t("Message")}</h5>
                  </div>

                  <div className="modal-close-icon">
                    <CloseIcon
                      onClick={handleConfirmationClose}
                      width={30}
                      height={30}
                    />
                  </div>
                </div>

                <div className="modal-message">{sendMessageToMarshalsStatus === API_STATUSES.SUCCESS ? t('Successfully_Forwarded_to_marshals') : sendMessageToMarshalsStatus === API_STATUSES.REQUEST ? t('Warning_Forwarded_to_marshals') : t('Error_Forwarded_to_marshals')}
                </div>
                <div className="marshal-icon">
                  <MarshalsCarIcon
                    width={18}
                    height={18} />
                </div>
              </div>
            </ModalContainer>
          </PopUpContainer>
        </Box>
      </Modal>
    );
  };

  const actionButton = (params) => {
    return (
      <div className="action-btn">
        <TagsWrapper className="table-btn-wrapper">
          <Tag
            onClick={(e) => (forwardMessagesToMarshal(e, params.row))}
            className="round-btn"
            title={t("Forward_messages_to_marshals")}
            disabled={!isUserAdmin(getUserRole && getUserRole?.Role) && !isUserMaster(getUserRole && getUserRole?.Role)}
          >
            <ForwardIcon
              disabled={!isUserAdmin(getUserRole && getUserRole?.Role) && !isUserMaster(getUserRole && getUserRole?.Role)}
              color="#777777"
              width={18}
              height={18} />

            <MarshalsCarIcon
              disabled={!isUserAdmin(getUserRole && getUserRole?.Role) && !isUserMaster(getUserRole && getUserRole?.Role)}
              color="#777777"
              width={18}
              height={14.9} />
          </Tag>

          <Tag
            onClick={(e) => sendMsgToSelectedCars(e, params.row)}
            className="round-btn"
          >
            <ChatIcon color="#777777" width={18} height={14.9} />
            <span>{t("Message_to_Car")}</span>
          </Tag>

          <Tag className="round-btn" onClick={() => fleetPageRedirect(params)}>
            <CarTagIcon color="#777777" width={11.5} height={16} />{" "}
            <span>{t("Find_Cars")}</span>
          </Tag>

          <DeleteIcon
            color="#FA3C30"
            width="14px"
            height="16px"
            className="delete-icon"
            onClick={() => {
              setMessageIdForDeletee(params);
              setOpenDeleteModal(true);
            }}
          />
        </TagsWrapper>
      </div>
    );
  };

  const stringComparator = (a, b) => {
    if (a < b) {
      return -1;
    }
    if (a > b) {
      return 1;
    }
    return 0;
  };
  const getRowHeight = (params) => {
    const content = `${params?.model?.Text}`;
    return content.length > 100 ? 100 : 50;
  }
  const columns = [
    {
      field: "received",
      headerName: t("Received"),
      width: 150,
      headerClassName: "lastcolumnSeparator display",
      renderCell: (params) => {
        return (
          <div className="super-time-theme--cell">
            <TimeIcon color="#0009" width={13} height={13} />
            {recvTime(params?.row)}
          </div>
        );
      },
    },
    {
      field: "car",
      headerName: t("Car"),
      width: 100,

      headerClassName: "lastcolumnSeparator",
      renderCell: (params) => {
        return <div className="time-theme--cell">{params.row?.CarNum}</div>;
      },
    },
    {
      field: "text",
      headerName: t("Text"),
      flex: 1,
      minWidth: 350,
      type: "string",
      headerClassName: "lastcolumnSeparator text-column",
      cellClassName: "word-wrap",
      renderCell: (params) => {
        return (
          <div
            className="time-theme--cell"
            style={{ display: "flex", alignItems: "flex-start" }}
          >
            {params.row?.IsDiagnostic && (
              <FaStethoscope
                style={{
                  fontSize: 14,
                  color: "#000",
                  marginRight: 6,
                  marginTop: 5,
                  flexShrink: 0
                }}
              />
            )}

            <span>{decodeHtml(params.row?.Text)}</span>
          </div>
        );
      },
    },
    {
      field: "response",
      headerName: t("Response"),
      headerClassName: "lastcolumnSeparator",
      type: "string",
      width: 200,
      renderCell: (params) => {
        return (
          <div className="time-theme--cell">{responseString(params?.row)}</div>
        );
      },
    },
    {
      field: "hole",
      headerName: t("Hole"),
      type: "string",
      headerClassName: "lastcolumnSeparator",
      width: 100,

      renderCell: (params) => {
        return (
          <div className="time-theme--cell">{holeString(params?.row)}</div>
        );
      },
    },
    {
      field: "action",
      headerName: t("Action"),
      description: "This column has a value getter and is not sortable.",
      sortable: false,
      width: 386,
      headerClassName: "lastcolumnSeparator display",
      renderCell: (params) => actionButton(params),
    },
  ];

  if (siteSettingDataReduxStateStatus === API_STATUSES.REQUEST) {
    return <Loader />;
  }

  const dismissMessages = () => {
    let dismissedIds = JSON.parse(localStorage.getItem("dismissedIds"));
    selectionModel?.forEach((dmId) => {
      dismissedIds.push(dmId);
    });
    localStorage.setItem("dismissedIds", JSON.stringify(dismissedIds));
    setOpenDismiss(false);
    // if (
    //   messageData &&
    //   messageData.length !== 0 &&
    //   selectionModel &&
    //   selectionModel.length !== 0
    // ) {
    //   const results = messageData.filter((item) =>
    //     selectionModel.some((item2) => item.Id === item2)
    //   );
    //   dispatch(setCarMessagesBackup(selectionModel));
    //   dispatch(setCarMessagesDataBackup(results));
    //   setOpenDismiss(false);
    //   setMessageData(results);
    // }
  };

  return (
    !getFeatureSetOption(
      siteSettingsData && siteSettingsData?.Features,
      getFeaturesList().real_time_tracking
    ) && (
      <>
        <Header>
          <CircleBtn
            onClick={() => setOpenDismiss(true)}
            disabled={selectionModel.length === 0}
            style={{ opacity: selectionModel.length === 0 ? "0.5" : "1" }}
          >
            <DeleteIcon color="#FA3C30" /> {t("Dismiss_all")}
          </CircleBtn>
        </Header>
        {singleMessageDelete()}
        {multipleMessagesDelete()}
        {confirmationModal()}
        <TableContainer className="inbox-table">
          <BodyWrapper>
            <TableInnerSection>
              <DataGrid
                className="inbox"
                hideFooter={true}
                components={{
                  NoRowsOverlay: () => (
                    <Stack
                      height="100%"
                      alignItems="center"
                      justifyContent="center"
                      fontSize={25}
                      fontWeight="bold"
                    >
                      {t("Inbox_is_empty")}
                    </Stack>
                  ),
                }}
                rows={messageData ? messageData : []}
                columns={columns}
                getRowHeight={getRowHeight}
                checkboxSelection
                disableSelectionOnClick
                disableColumnMenu
                getRowId={(r) => r.Id}
                onSelectionModelChange={(itm) => setSelectionModel(itm)}
                sortComparator={stringComparator}
              />
            </TableInnerSection>
          </BodyWrapper>
        </TableContainer>
      </>
    )
  );
};

export default InboxTable;
